import * as FlagIcons   from 'country-flag-icons/react/3x2';
import React            from 'react';
import { AllCountries } from 'tools/Countries';

export default function getFlagFromCountryCode(countryCode: string) {
	const FlagComponent = FlagIcons[countryCode];

	return <FlagComponent style={{ height: 'auto', width: 20 }} title={AllCountries[countryCode]} />;
}